'use strict';

module.exports = function (ngModule) {
    ngModule.controller('manageFeedController', require('./manage_feeds'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/feeds/index.js
 **/